import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./template/Layout";
import Home from "./pages/Home";
import Services from "./pages/Services";
import FAQ from "./pages/FAQ";
import About from "./pages/About";
import Blog from "./pages/Blog";
import Contact from "./pages/Contact";
import ContactSuccess from "./pages/ContactSuccess";
import BlogPost from "./pages/BlogPost";
import Calendly from "./pages/Calendly";
const App = () => {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/about" element={<About />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/contact/success" element={<ContactSuccess />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/book" element={<Calendly />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
};

export default App;
